@if (isAuthenticated && authenticationService.showSidebar()) {
  <div class="sidenav-sidenav {{ themesService.themeClass }}">
    @if (isAuthenticated && authenticationService.showSidebar()) {
      <div class="sidenav-content bg-white">
        <div class="menu-logo-container">
          @if (!navbarService.isDesktop) {
            <button
              mat-button
              type="button"
              class="menu-button"
              (click)="navbarService.closeMenu()">
              <img src="assets/img/dashboard/cross.svg" />
            </button>
          }
          <h1 class="p-header__company" (click)="openHomePage()">
            <img
              src="assets/img/Tongo_logo_new_2.svg"
              class="p-header__logo"
              alt="Tongo Logo" />
          </h1>
        </div>
        @if (navbarService.isDesktop) {
          <div class="tab-title">
            {{ user?.firstName }} {{ user?.lastName }}
          </div>
        }
        <mat-divider class="divider-header"></mat-divider>
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="font-sidebar">
                  {{
                    'left-menu.component.your_account'
                      | localise: 'Your Account'
                  }}
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <a
              class="link"
              routerLink="/dashboard"
              routerLinkActive="router-link-active"
              (click)="navbarService.closeMenuIfMobile()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/dashboard.svg" />
              <div class="nav-item-name">
                {{ 'left-menu.component.dashboard' | localise: 'Dashboard' }}
              </div>
            </a>
            <a
              class="link"
              routerLink="/commissions"
              routerLinkActive="router-link-active"
              (click)="navbarService.closeMenuIfMobile()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/commissions.svg" />
              <div class="nav-item-name">
                {{
                  'left-menu.component.commissions_link'
                    | localise: 'Commissions'
                }}
              </div>
            </a>
            @if (!!user?.productIds?.includes(productEnum.Advance)) {
              <a
                class="link"
                routerLink="/activity"
                routerLinkActive="router-link-active"
                (click)="navbarService.closeMenuIfMobile()">
                <img
                  class="icon-svg icon-size-25"
                  src="assets/img/icons/transactions.svg" />
                <div class="nav-item-name">
                  {{
                    'left-menu.component.transactions_link'
                      | localise: 'Transactions'
                  }}
                </div>
              </a>
            }
            @if (!!user?.productIds?.includes(productEnum.Payment)) {
              <a
                class="link"
                routerLink="/payroll-settings"
                routerLinkActive="router-link-active"
                (click)="navbarService.closeMenuIfMobile()">
                <img
                  class="icon-svg icon-size-25"
                  src="assets/img/icons/distributions.svg" />
                <div class="nav-item-name">
                  {{
                    'left-menu.component.distributions_button'
                      | localise: 'Distributions'
                  }}
                </div>
              </a>
            }
            @if (
              user?.featureInvoicesFlag && !!user?.invitesFromPartner?.length
            ) {
              <a
                class="link"
                routerLink="/invoices"
                routerLinkActive="router-link-active"
                (click)="navbarService.closeMenuIfMobile()">
                <img
                  class="icon-svg icon-size-25"
                  src="assets/img/icons/invoices.svg" />
                <div class="nav-item-name">
                  {{
                    'left-menu.component.invoices_button' | localise: 'Invoices'
                  }}
                </div>
              </a>
            }
            <a
              class="link"
              routerLink="/statements"
              routerLinkActive="router-link-active"
              (click)="navbarService.closeMenuIfMobile()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/statements.svg" />
              <div class="nav-item-name">
                {{
                  'left-menu.component.statements_button'
                    | localise: 'Statements'
                }}
              </div>
            </a>
            @if (user?.featureAprilMarketingFlag && user?.showAprilMarketing) {
              <a
                class="link"
                routerLink="/taxes"
                routerLinkActive="router-link-active"
                (click)="navbarService.closeMenuIfMobile()">
                <img
                  class="icon-svg icon-size-25"
                  src="assets/img/icons/taxes.svg" />
                <div class="nav-item-name">
                  {{ 'left-menu.component.taxes' | localise: 'Taxes' }}
                </div>
              </a>
            }
            <a
              class="link"
              routerLink="/bank-accounts"
              routerLinkActive="router-link-active"
              (click)="navbarService.closeMenuIfMobile()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/bank-settings.svg " />
              <div class="nav-item-name">
                {{
                  'left-menu.component.bank_settings_button'
                    | localise: 'Bank Settings'
                }}
              </div>
            </a>
            @if (user?.featureUnitBankingFlag) {
              <a
                class="link"
                routerLink="/banking"
                routerLinkActive="router-link-active"
                (click)="navbarService.closeMenuIfMobile()">
                <img
                  class="icon-svg icon-size-25"
                  src="assets/img/icons/taxes.svg" />
                <div class="nav-item-name">
                  {{ 'left-menu.component.banking' | localise: 'Banking' }}
                </div>
              </a>
            }
          </mat-expansion-panel>
        </mat-accordion>
        <mat-divider></mat-divider>
        <mat-accordion>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="font-sidebar">
                  {{ 'left-menu.component.settings' | localise: 'Setting' }}
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <a
              class="link"
              routerLink="/profile"
              routerLinkActive="router-link-active"
              (click)="navbarService.closeMenuIfMobile()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/personal-information.svg" />
              <div class="nav-item-name">
                {{
                  'left-menu.component.personal_information'
                    | localise: 'Personal Information'
                }}
              </div>
            </a>
            <a
              class="link c-white"
              routerLink="/agreement"
              routerLinkActive="router-link-active"
              (click)="navbarService.closeMenuIfMobile()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/product-terms-and-contract.svg" />
              <div class="nav-item-name">
                {{
                  'left-menu.component.product_terms_and_contract_button'
                    | localise: 'Product Terms & Contract'
                }}
              </div>
            </a>
            <a
              class="link"
              (click)="openHelp(); navbarService.closeMenuIfMobile()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/help.svg" />
              <div class="nav-item-name">
                {{
                  'left-menu.component.help_and_support'
                    | localise: 'Help & Support'
                }}
              </div>
            </a>
            <a class="link" (click)="logout()">
              <img
                class="icon-svg icon-size-25"
                src="assets/img/icons/logout.svg" />
              <div class="nav-item-name">
                {{ 'left-menu.component.logout' | localise: 'Logout' }}
              </div>
            </a>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-divider></mat-divider>
        <div class="promo-invite">
          <h1>
            <img src="assets/img/dashboard/gift-2.svg" />
            {{
              'sidebar.component.invite_earn_title' | localise: 'Invite & earn'
            }}
          </h1>
          <div class="slogan-promo">
            Share your code and earn
            {{
              bonusAmount
                | currencyJs: { showSymbol: true, withoutDecimal: true }
            }}
            for each friend who joins!
          </div>
          @if (isReward) {
            <div class="is-reward">
              <div>●</div>
              <div>Congrats! You have a new reward!</div>
            </div>
          }
          @if (isReward) {
            <button
              (click)="openPromoCodeView()"
              class="promo-action claim-transfer">
              <img src="assets/img/icons/spark.svg" />
              Claim
              {{
                amountReward
                  | currencyJs: { showSymbol: true, hideZeroDecimal: true }
              }}
            </button>
          }
          <button (click)="openPromoCodeView()" class="promo-action">
            <mat-icon>add_circle_outline</mat-icon>
            {{
              'sidebar.component.invite_friends' | localise: 'Invite friends'
            }}
          </button>
        </div>
        <div class="sidenav-footer">
          <!--      PAY-3034 Retire Dark Mode -->
          <!--      <span class="sidenav-footer-text">{{-->
          <!--        'left-menu.component.footer-text-theme' | localise : 'Theme'-->
          <!--      }}</span>-->
          <!--      <div class="sidenav-footer-mode">-->
          <!--        <app-theme-switcher-->
          <!--          [sliderText]="-->
          <!--            'left-menu.component.footer-text-mode' | localise : 'Dark Mode'-->
          <!--          "></app-theme-switcher>-->
          <!--      </div>-->
        </div>
      </div>
    }
  </div>
}

<ng-template #promoCodeTmp>
  <div class="referral-modal">
    <div class="header-referral">
      <h1>
        {{
          'sidebar.component.referral_title'
            | localise: 'Invite your colleagues to join Tongo!'
        }}
      </h1>
      <mat-icon mat-dialog-close>close</mat-icon>
    </div>
    <div class="referral-content">
      <div class="referral-code">
        <img src="assets/img/dashboard/referral.svg" />
        <div class="block-code">
          <h1>
            {{
              'sidebar.component.share_referral_code'
                | localise: 'Share your referral code'
            }}
          </h1>
          <div class="code">
            {{ user?.referralInviteCode }}
            <div (click)="copyCode()" class="copy">
              <img src="assets/img/dashboard/link-chain.svg" />
              {{ 'sidebar.component.copy' | localise: 'Copy' }}
            </div>
          </div>
        </div>
      </div>
      @if (amountReward.value) {
        <div class="block-code color-green">
          <div class="img-claim-transfer">
            <mat-icon>check</mat-icon>
          </div>
          <div class="referral-success">
            <div>
              {{
                'sidebar.component.referral_success'
                  | localise: 'Your referral was successful!'
              }}
            </div>
            <div>
              {{ 'sidebar.component.you_earned' | localise: 'You’ve earned' }}
              {{
                amountReward
                  | currencyJs: { showSymbol: true, hideZeroDecimal: true }
              }}
              {{
                'sidebar.component.in_your_tongo'
                  | localise: 'in your Tongo available limit'
              }}
            </div>
          </div>
          @if (false) {
            <div mat-dialog-close (click)="claimReward()" class="copy">
              <img src="assets/img/dashboard/gift-white.svg" />
              {{
                'sidebar.component.claim_reward' | localise: 'Claim my reward'
              }}
            </div>
          }
        </div>
      }
      <div class="instruction">
        <h1>
          {{ 'sidebar.component.how_it_works' | localise: 'How it works' }}
        </h1>
        <div class="step">
          <div class="number">
            <div class="number-step">1</div>
            <div class="line-stepper"></div>
          </div>
          <div class="stepper-name">
            <h1>
              {{
                'sidebar.component.step_share_code_title'
                  | localise: 'Share your code'
              }}
            </h1>
            <div class="stepper-description">
              {{
                'sidebar.component.step_share_code_desc'
                  | localise
                    : "Send your unique referral code to friends. They'll use it during signup."
              }}
            </div>
          </div>
        </div>
        <div class="step">
          <div class="number">
            <div class="number-step">2</div>
            <div class="line-stepper"></div>
          </div>
          <div class="stepper-name">
            <h1>
              {{
                'sidebar.component.step_friend_signup_title'
                  | localise: 'Friend signs up'
              }}
            </h1>
            <div class="stepper-description">
              {{
                'sidebar.component.step_friend_signup_desc'
                  | localise
                    : 'They create an account, enter your referral code, and apply for their advance.'
              }}
            </div>
          </div>
        </div>
        <div class="step">
          <div class="number">
            <div class="number-step">3</div>
          </div>
          <div class="stepper-name">
            <h1>
              {{
                'sidebar.component.step_both_rewarded_title'
                  | localise: 'Both get rewarded!'
              }}
            </h1>
            <div class="stepper-description">
              Once their Commission Advance is approved, you both receive
              {{
                bonusAmount
                  | currencyJs: { showSymbol: true, withoutDecimal: true }
              }}!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
